import styled from 'styled-components';
import { BaseStyledComponentProps } from '../../utils/styles-constants';

interface PageTitleProps {
	hasClearButton: boolean;
}

const StyledTitle = styled('div')`
	color: ${(props: BaseStyledComponentProps) => {
		return props.theme.primary.strongColor;
	}};
	text-decoration: none;
	font-weight: 600;
	font-size: 18px;
	letter-spacing: 0.5px;
	line-height: 30px;
`;

const PageTitle = styled(StyledTitle)`
	box-sizing: border-box;
	position: relative;
	display: flex;
	justify-content: space-between;
	padding-left: 10px;

	${({ hasClearButton }: PageTitleProps) => hasClearButton && 'width: 100%;'}
`;

export { PageTitle, StyledTitle };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Title/styles.ts